export const userPolicyList = `
query Userlist($userId: Int!) { 
  policyByUser(userId: $userId) { 
    id 
    status 
    statusAt 
    createdAt 
    policy { 
      id 
      title 
      description 
      document 
    } 
    user { 
      id 
      firstName 
      lastName 
    } 
  } 
}`;

export const allPolicyList = `
query allPolicies{ 
  allPolicies { 
    id 
    title 
    description 
    document 
    isActive 
    createdAt 
    updatedAt 
  } 
}`;

export const postUserPolicy = `
mutation createPolicy($input: CreatePolicyInput!) { 
  createPolicy(input: $input) { 
    success 
    message 
  } 
} `;

export const putUserPolicy = `
mutation updatePolicy($input: UpdatePolicyInput!) { 
  updatePolicy(input: $input) { 
    success 
    message 
  } 
} `;

export const getPolicyById = `
query getPolicyById($policyId: Int!) { 
  policyById(policyId: $policyId) { 
    id 
    title 
    description 
    document 
    isActive 
    createdAt 
  } 
} `;

export const updatePolicyStatus = `
mutation updatePolicyStatus($input: UpdatePolicyStatusInput!) { 
  updatePolicyStatus(input: $input) { 
    success 
    message 
  } 
} `;

export const getUserDetailsByPolicyId = `
query PolicywiseUserStatus ($policyId: Int!) { 
  policywiseUserStatus(policyId: $policyId) { 
    status 
    statusAt 
    user { 
      firstName 
      lastName 
    } 
    policy { 
      title 
    } 
  } 
} `;